import type { RouteRecordRaw } from 'vue-router';

/** Portal routes live at the top level, outside the app shell — the
 *  customer opens the URL from an email and must NOT hit the tenant
 *  admin login. `skipTenantGuard` lets tenantGuard pass through
 *  regardless of subdomain. */
export const portalRoutes: RouteRecordRaw[] = [
  {
    path: '/q/:token',
    name: 'portal.quote',
    component: () => import('./pages/PortalQuotePage.vue'),
    meta: {
      title: 'Quote',
      requiresAuth: false,
      skipTenantGuard: true,
    },
  },
  {
    path: '/v/:token',
    name: 'portal.vehicle',
    component: () => import('./pages/PortalVehiclePage.vue'),
    meta: {
      title: 'Service history',
      requiresAuth: false,
      skipTenantGuard: true,
    },
  },
  {
    path: '/find-vehicle',
    name: 'portal.vehicle.lookup',
    component: () => import('./pages/PortalVehicleLookupPage.vue'),
    meta: {
      title: 'Find my service history',
      requiresAuth: false,
      skipTenantGuard: true,
    },
  },
];
